import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import AppSystemApi from '../generated/api/AppSystem';

export default (service: Servicelayer) => ({
  ...AppSystemApi(service),

  // Add custom calls here

});
